import { render, staticRenderFns } from "./Developer3.vue?vue&type=template&id=09e4ffce"
import script from "./Developer3.vue?vue&type=script&lang=js"
export * from "./Developer3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports